import React from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import { fr } from 'date-fns/locale';
import 'react-datepicker/dist/react-datepicker.css';
import './DateTimePicker.css';

registerLocale('fr', fr);

const parseValue = (value) => {
  if (!value) return null;
  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d;
};

const formatValue = (date) => {
  if (!date) return '';
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  const h = String(date.getHours()).padStart(2, '0');
  const min = String(date.getMinutes()).padStart(2, '0');
  return `${y}-${m}-${d}T${h}:${min}`;
};

const DateTimePicker = ({ value, onChange, placeholder = 'jj/mm/aaaa hh:mm', className = '' }) => {
  return (
    <DatePicker
      selected={parseValue(value)}
      onChange={(date) => onChange(formatValue(date))}
      showTimeSelect
      timeIntervals={15}
      timeCaption="Heure"
      dateFormat="dd/MM/yyyy HH:mm"
      timeFormat="HH:mm"
      locale="fr"
      placeholderText={placeholder}
      className={`date-input datetime-input ${className}`}
      isClearable
      autoComplete="off"
    />
  );
};

export default DateTimePicker;
